import React, { useEffect, useState } from "react";
import { Field } from "redux-form";

import {
  voidRequired,
  phoneFormat,
  email,
  nameFormat,
  notNegative,
  cirillicResist,
  nameValidation,
} from "../../../../helpers/validate";

import Input from "../../../components/formComponent/Input/Input";
import FileUploader from "../../../components/formComponent/PhotoPassUploader/PhotoPassUploader";
import DatePicker from "../../../components/formComponent/DatePicker/DatePicker";
import Button from "../../../components/ui/Button/Button";
import FilterSelect from "../../../components/formComponent/FilterSelect/FilterSelect";
import Selecter from "../../../components/formComponent/Select/Select";

import trash from "../../../../style/icons/Trash/trash.svg";
import arrowLeft from "../../../../style/icons/ArrowLeftLight/arrow-left.svg";
import plus from "../../../../style/icons/PlusInCircle/plus.svg";
import shevroRight from "../../../../style/icons/ShevronRight/shevron.svg";
import docAvatar from "../../../../style/icons/DoctorAvatar/avatar.svg";
import calendar from "../../../../style/icons/Calendar/calendar.svg";
import close from "../../../../style/icons/Close/close-icon.svg";
import TextArea from "../../../components/formComponent/TextArea/TextArea";
import { useTranslation } from "react-i18next";
import moment from "moment";

let firstAge = 0;

const experienceValidation = (value) => {
  const minRequiredAge = 18;
  const years = +value;
  const isPositiveNumber = years === Math.abs(years);
  if (value) {
    if (!firstAge) return undefined;
    if (!isPositiveNumber) return true;
    if (firstAge < minRequiredAge && years > 0) return true;
    if (firstAge < minRequiredAge && years === 0) return undefined;
    return years + minRequiredAge > firstAge ? true : undefined;
  }
  // Explicitly return undefined for empty values
  return undefined;
};

const Doc = ({
  setAddingImg,
  formValues = {},
  addingImg,
  initialValues,
  setInitalValues,
  setEditingOff,
  reset,
  fillType,
  specializations,
  setBlob,
  isBlocked,
  editingSpecialties,
  setMadeChanges,
}) => {
  // const [maxExperience, setMaxExperience] = useState(0)
  const { t } = useTranslation();
  const [age, setAge] = useState(1);

  useEffect(() => {
    console.log("!!!!!!!!!!!!! useEffect", formValues.birthDate);
    if (formValues.birthDate) {
      setAge(getAge(formValues.birthDate));
      firstAge = getAge(formValues.birthDate);
    }
    
    // Cleanup function to reset firstAge when component unmounts
    return () => {
      firstAge = 0;
    };
  }, [formValues.birthDate]);

  const getAge = (birthDate) => {
    const age = moment().diff(birthDate, 'years');
    return age
  };

  return (
    <>
      <div className="commonInfo">{t("common")}</div>
      {addingImg && (
        <div className={`addingImg ${addingImg ? "show" : ""}`}>
          <div className="formTitle">
            <img
              src={arrowLeft}
              alt="arrow-icon"
              onClick={() => {
                setAddingImg(false);
                setEditingOff();
              }}
            />
            {t("addImage")}
          </div>
          <div className="photoUploadFieldContainer">
            <Field
              name="photo"
              // validate={[voidRequired]}
              component={FileUploader}
              previewTrashIcon={trash}
              // uploadReq={() => console.log("action")}
              close={() => setAddingImg(false)}
              editingImgUrl={
                initialValues &&
                initialValues.photo &&
                initialValues.photo.cropImg
              }
              setBlob={setBlob}
              setEditingOff={setEditingOff}
              disabled={isBlocked}
              t={t}
            />
          </div>
        </div>
      )}

      {formValues && formValues.photo && formValues.photo.cropImg ? (
        <div className="specAvatar">
          <div className="flex alignCenter">
            <img
              className="cropPhoto"
              src={formValues.photo.cropImg}
              alt="avatar-icon"
            />
            <div className="fileName">
              {formValues && formValues.photo && formValues.photo.fileName}
            </div>
          </div>
          <div
            className="trashIcon"
            onClick={() => {
              reset();
              setInitalValues({
                ...formValues,
                photo: null,
              });
            }}
          >
            <img src={trash} alt="" />
          </div>
        </div>
      ) : (
        <Button
          secondary
          withIcon
          icon={plus}
          // shevron={shevroRight}
          type="button"
          className="btn"
          text={t("addImage")}
          onClick={() => setAddingImg(true)}
          disabled={isBlocked}
        />
      )}
      <Field
        name="firstName"
        validate={[nameValidation]}
        erorrValidate={t("firstNameIsIncorrect")}
        errorRequire={t("requiredValidate")}
        component={Input}
        placeholder={t("name")}
        disabled={isBlocked}
      />

      <Field
        name="lastName"
        validate={[nameValidation]}
        erorrValidate={t("lastNameIsIncorrect")}
        errorRequire={t("requiredValidate")}
        component={Input}
        placeholder={t("lastName")}
        disabled={isBlocked}
      />

      <Field
        name="patronymic"
        validate={[nameValidation]}
        erorrValidate={t("patronymicIsIncorrect")}
        errorRequire={t("requiredValidate")}
        component={Input}
        placeholder={t("patronymic")}
        disabled={isBlocked}
      />

      <div className="dateOfBith">
        <Field
          validate={[voidRequired]}
          name={`birthDate`}
          inputProps={{
            name: "birthDate",
          }}
          // validate={[required, date, maxDateNow]}
          component={DatePicker}
          // placeholder="--/--/----"
          placeholder={t("birthDate")}
          validDate={{ number: 18, type: "year", period: "isBefore" }}
          disabled={isBlocked}
        />
        <img
          className="closeImg"
          src={close}
          alt="close"
          onClick={async () => {
            await setInitalValues({
              ...formValues,
              birthDate: null,
            });
            let picker = document.getElementsByClassName("form-control");
            for (let i = 0; i < picker.length; i++) {
              const element = picker[i];
              element.value = "";
            }
          }}
        />
        <img className="calendarImg" src={calendar} alt="calendar" />
      </div>

      <Field
        name="sex"
        options={[t("maleSex"), t("femaleSex")]}
        // validate={[voidRequired]}
        component={Selecter}
        placeholder={t("gender")}
        disabled={isBlocked}
      />

      <Field
        name="email"
        validate={[voidRequired, email]}
        errorValidate={t("emailIsIncorrect")}
        errorRequire={t("emailIsRequire")}
        component={Input}
        placeholder={t("email")}
        mask={cirillicResist}
        disabled={isBlocked}
      />

      <Field
        name="phone"
        validate={[phoneFormat]}
        errorRequire={t("phoneIsRequire")}
        component={Input}
        placeholder={t("phoneNumber")}
        disabled={isBlocked}
      />

      <Field
        // validate={[voidRequired]}
        name="description"
        type="number"
        component={TextArea}
        placeholder={t("specializationDescription")}
        disabled={isBlocked}
      />

      <Field
        name="specialty"
        component={FilterSelect}
        validate={[voidRequired]}
        placeholder={t("placeholderSpecialty")}
        options={specializations}
        startedOptions={editingSpecialties}
        setMadeChanges={setMadeChanges}
        withSearch
        withIcon
        multiple
        icon={plus}
        withPreview={formValues && formValues.specialty}
        previewIcon={docAvatar}
        disabled={isBlocked}
      />

      <div className="commonInfo">{t("education")}</div>

      <Field
        name="educationType"
        component={Input}
        validate={[voidRequired]}
        placeholder={t("typeEducation")}
        errorRequire={t("requiredValidate")}
        disabled={isBlocked}
        allowSpaces
      />

      <Field
        name="educationSpecialty"
        validate={[voidRequired]}
        component={Input}
        placeholder={t("education")}
        errorRequire={t("requiredValidate")}
        disabled={isBlocked}
        allowSpaces
      />

      <div className="commonInfo">{t("experience")}</div>

      <Field
        name="experience"
        validate={[experienceValidation]}
        erorrValidate={`${t("experienceIsIncorrect")} ${
          // age === 0 ? age : age - 18
          (age - 18) > 0 ? age - 18 : 0
        }`}
        errorRequire={t("experienceIsRequire")}
        component={Input}
        type="number"
        // max={getAge(formValues?.birthDate) - 18}
        placeholder={t("old")}
        disabled={isBlocked}
      />
    </>
  );
};

export default Doc;
